<template>
  <div>
    <el-select :value="value" :disabled="disabled" value-key="key" :size="size" :placeholder="$t('table.type')" @input="change($event)" :clearable="true">
      <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      options: [
        // {key: 0, value: '微信'},
        {key: 1, value: '支付宝'}
        // {key: 2, value: '银行卡'}
      ]
    }
  },
  props: ['value', 'config', 'disabled', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/WithdrawalsSelect.vue